module.exports = __webpack_public_path__ + "static/media/88.679579e1.jpg";